module.exports = __webpack_public_path__ + "static/ballarat_care_story-d8685b9e1d6bd2410c64ad9846b778c1.png";